<template>
  <p
    class="flex-fJstart-fAcenter"
  >
    <span class="label"> {{ designation }} </span>
    <span
      class="flex-fJstart-fAcenter selectBox"
    >
      <select
        :id="id"
        v-model="selectedCache"
        @change="onChange"
      >
        <option
          v-for="(concernedArticles, option) of options"
          :key="option"
          :value="option"
        >
          {{ option }} {{ suffixe }}
        </option>
      </select>
      <span class="flex-fJcenter-fAcenter icon-arrowdown" />
    </span>
  </p>
</template>
<script>
export default {
  props: {
    selected: {
      type: String,
      required: true
    },
    propriete: {
      type: String,
      required: true
    },
    designation: {
      type: String,
      required: true
    },
    nature: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    suffixe: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      selectedCache: this.selected
    }
  },
  computed: {
    id() {
      return `${this.nature}.${this.propriete}.select`
    }
  },
  methods: {
    onChange() {
      const { selectedCache, propriete, nature } = this
      this.$emit('change', { propriete, nature, selected: selectedCache })
    }
  }
}
</script>
